export default __webpack_public_path__ + "static/media/navback_icon.e260302f.svg";